
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Card, TaskItem } from '../../backend/backendapi';
import { KanbanState } from '../kanban.model';
import $ from 'jquery';
import { handleError } from '../../../api';

@Component({
  name: 'TaskItemModal',
  components: {},
})
export default class TaskItemModal extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  private card: Card | null = null;
  private taskItem: TaskItem | null = null;

  private name: string = null!;
  private description: string | null = null;

  private get canSave(): boolean {
    return !!this.taskItem
        && ((this.taskItem.name ?? '').trim() !== (this.name ?? '').trim()
            || (this.taskItem.description ?? '').trim() !== (this.description ?? '').trim());
  }
  
  private get descriptionRowCount(): number {
    return (this.description ?? '').split('\n').length;
  }

  public open(card: Card, taskItem: TaskItem): void {
    this.card = card;
    this.taskItem = taskItem;
    this.name = taskItem.name ?? null;
    this.description = taskItem.description ?? null;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  private async onSave(): Promise<void> {
    if (!this.card || !this.taskItem) {
      return;
    }

    const card = this.card;
    const taskItem = this.taskItem;
    const request = new TaskItem(taskItem);
    request.name = this.name;
    request.description = this.description ?? '';
    try {
      await this.state.taskAPI.update(request);

      taskItem.name = request.name;
      taskItem.description = request.description;
      card.updatedOnForReadConfirmation = new Date();
      
      this.$toasted.info(this.$t('txtSaved').toString());
      this.dismiss();
    } catch (error) {
      handleError(this.$toasted, this.$i18n, error);
    }
  }
}
